import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import TextBox from './OptionsTextBox';
import Css from './Options.scss';
import { Modal, ModalBody } from 'reactstrap';
import ImportImages from '@src/importImages';

const Membership = ImportImages('/suitekey/membership.png');
const Clouds = ImportImages('/home/clouds.jpg');

const options = props => {
  let styles = {};
  let classNames = '';
  if (window.innerWidth < 992) {
    styles.minHeight = props.screenHeight + 'px';
    styles.backgroundImage = `url(${Clouds})`;
    styles.backgroundSize = '100% 100%';
    styles.backgroundPosition = 'center center';
    classNames = 'pt-6 pb-4';
  } else {
    styles.height = props.screenHeight + 'px';
    classNames = 'abs-container d-flex align-items-center';
  }

  const BenefitsContent = props.modalContent;

  return (
    <div id={props.id} className={props.className} style={styles}>
      <img
        src={Clouds}
        alt={'Slider1'}
        className={'img-fluid d-none d-lg-block'}
      />
      <Container fluid={true} className={classNames}>
        <Row className={'justify-content-center'}>
          <Col md={9} xs={12}>
            <Row>
              <Col md={6} xs={12}>
                <TextBox {...props} style={{ height: '100%' }} />
              </Col>
              <Col md={6} xs={12} className={Css['membership-levels']}>
                <div className={Css.container + ' px-5'}>
                  <img
                    src={Membership}
                    className={'img-fluid mx-auto d-block'}
                    alt={'Membership levels'}
                  />
                  <div className={Css.label + ' pt-3 lakes-medium'}>
                    Membership Levels
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <Modal
        isOpen={props.modalActive}
        toggle={props.toggleModal}
        className={
          'modal-lg h-100 d-flex flex-column justify-content-center my-0'
        }
      >
        <ModalBody style={{ backgroundColor: '#eeeeee' }}>
          <div className="p-3" style={{ border: '1px solid red' }}>
            <BenefitsContent />
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default options;



// WEBPACK FOOTER //
// ./src/components/SuiteKey/Options/Options.js